var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        "label-position": "top",
        rules: _vm.rules,
        "label-width": "600px",
        width: "600px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("rateCalculator.table.CustomerName"),
                prop: "customName",
              },
            },
            [
              _c("BjInput", {
                attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                model: {
                  value: _vm.form.customName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "customName", $$v)
                  },
                  expression: "form.customName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("rateCalculator.table.profitmargin"),
                prop: "profitMargin",
              },
            },
            [
              _c("BjInputMoney", {
                attrs: {
                  max: 90,
                  min: 0,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.profitMargin,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "profitMargin", $$v)
                  },
                  expression: "form.profitMargin",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("rateCalculator.table.ShippingAddress") },
            },
            [
              _c("BjInput", {
                attrs: {
                  disabled: "",
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.fromAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "fromAddress", $$v)
                  },
                  expression: "form.fromAddress",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.byPostCode"),
                prop: "isPostcode",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "option-list": _vm.STATUS_YES_TRUE, clearable: false },
                model: {
                  value: _vm.form.isPostcode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "isPostcode", $$v)
                  },
                  expression: "form.isPostcode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("rateCalculator.table.Fileupload"),
                prop: "logistics",
              },
            },
            [
              _c(
                "span",
                { staticClass: "downtext", on: { click: _vm.downFile } },
                [_vm._v(_vm._s(_vm.$t("ExcelConfig.Download")))]
              ),
              _c(
                "el-upload",
                {
                  ref: "uploadRef",
                  attrs: {
                    accept: ".csv,.xls,.xlsx",
                    action: "",
                    limit: 1,
                    "auto-upload": false,
                    "on-change": _vm.handleChange,
                  },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.ClickImport"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.chooseLogistics"),
                prop: "postCodeList",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.LogisticsSelectionData,
                  multiple: "",
                },
                model: {
                  value: _vm.form.postCodeList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "postCodeList", $$v)
                  },
                  expression: "form.postCodeList",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }